module.exports = __webpack_public_path__ + "media/images/wedding/26-92e85d7ea806d6e4cfdd09735670f30f.jpg";